export default {
  getters: {
    getAccountApps: state => state.currentAccountApps,
    getApps: state => state.currentApps,
    getAppServices: state => state.currentAppServices,
  },
  mutations: {
    clearAccountApps(state) { state.currentAccountApps = [] },
    setAccountApps(state, value) {
      state.currentAccountApps = value
    },
    setApps(state, value) {
      state.currentApps = value

      const services = []
      value.forEach(app => {
        const appServices = app.services.sort((obj, obj1) => (obj.name > obj1.name) ? 1 : ((obj1.name > obj.name) ? -1 : 0))
        appServices.forEach(service => {
          services.push({ ...service, appName: app.name, nickname: app.nickname })
        })
      })
      state.currentAppServices = services
    }
  },
  state: {
    currentAccountApps: [],
    currentApps: [],
    currentAppServices: [],
  }
}
